import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-usergroup03grey',
  standalone: true,
  templateUrl: '../../assets/usergroup03grey.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamUsergroup03greyIcon {}
